// extracted by mini-css-extract-plugin
export default {"btnBack":"GooBack_btnBack__588Yr","title":"GooBack_title__m13US","svg":"GooBack_svg__QZn5e"};